// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2wkIS","content":"ManualTimeModal_content__2N2KU"};